import { Injectable, inject } from '@angular/core';
import { RestApiService } from '@core/services/rest-api.service';
import { AddressLookupResp } from '@shared/interfaces/address-lookup';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarConfig } from '@shared/constants/snackbar-config';
import { Observable } from 'rxjs';
import { Coordinates } from '../interfaces';
import { DvSnackbarService } from '@devinco/ui/dds/snackbar';

@Injectable({ providedIn: 'root' })
export class AddressSearchService {
  private api = inject(RestApiService);
  private snackbar = inject(DvSnackbarService);
  private translate = inject(TranslateService);

  getGPSPositionFromAddress(address: {
    Address?: string | undefined;
    PostalPlace?: string | undefined;
  }): Observable<AddressLookupResp[]> {
    return this.api.postCustom<AddressLookupResp[]>(
      'POI/lookup/AddressToPosition',
      {
        Address: address.Address,
        PostalPlace: address.PostalPlace,
        NumberOfHits: 5,
      }
    );
  }

  getAddressFromGPSPosition(
    coordinates: Coordinates
  ): Observable<AddressLookupResp[]> {
    return this.api.postCustom<AddressLookupResp[]>(
      'POI/lookup/PositionToAddress',
      {
        Longitude: coordinates.lng,
        Latitude: coordinates.lat,
        NumberOfHits: 5,
      }
    );
  }

  showNoAddressHitInfoMsg(): void {
    this.snackbar.open(
      this.translate.instant('POI.NoAddressFound'),
      SnackBarConfig.Warning
    );
  }
}
